import SIP from './SIP';

export { SIP };



// WEBPACK FOOTER //
// src/modules/screens/settings/SIP/components/index.js